import { yupToFormErrors } from 'formik'
import { ObjectSchema, Schema } from 'yup'

export const validateFieldWithYup = (schema: Schema<any> | ObjectSchema<any>) => (values: any) =>
  schema
    .validate(values, { abortEarly: false })
    .then((values: any) => null)
    .catch((error: any) => {
      return yupToFormErrors(error)
    })
